import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { HEADER, MEMBER } from '_constants';
import { headerActions, dashboardActions, userprofileActions } from 'actions';

import * as memberSelectors from '../../../reducers/member.reducer';
import alertIcon from 'assets/img/alert-icon.svg';

const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Out of Office',
  hasBackButton: true,
  hasNotificationIcon: true,
  showFooterWithBackButton: false
};

class OutOfOffice extends React.Component {
  static propTypes = {
    setHeader: PropTypes.func.isRequired,
    deleteOutOfOffice: PropTypes.func.isRequired,
    updateOutOfOffice: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getMember: PropTypes.func.isRequired,
    setOutOfOffice: PropTypes.func.isRequired,
    userprofile: PropTypes.shape({
      memberKey: PropTypes.string
    }),
    outOfOffice: PropTypes.shape({
      startDateTime: PropTypes.string,
      endDateTime: PropTypes.string,
      outOfOfficeKey: PropTypes.number
    })
  }

  state = {
    isOutOfOffice: this.props.outOfOffice,
    isOOOError: false,
    isRangeError: false,
    isPassedDateError: false,
    initialStartDate: '',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  }

  submitOutofOffice = (e) => {
    e.preventDefault();
    const payload = {
      startDateTime: moment(this.state.startDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
      endDateTime: moment(this.state.endDate).utc().add(1, 'd').format('YYYY-MM-DDTHH:mm:ss')
    };

    if (this.props.outOfOffice.outOfOfficeKey) {
      const oooKeys = {
        memberKey: this.props.userprofile.memberKey,
        outOfOfficeKey: this.props.outOfOffice.outOfOfficeKey
      };
      payload.outOfOfficeKey = this.props.outOfOffice.outOfOfficeKey;
      this.props.updateOutOfOffice(oooKeys, payload);
    } else {
      this.props.setOutOfOffice(this.props.userprofile.memberKey, payload);
    }
    this.props.history.goBack();
  }

  validateValues = () => {
    this.confirmEquality();
    this.confirmDateRange();
    this.confirmPassedDate();
  }

  confirmPassedDate = () => {
    const today = moment(new Date());
    const startInput = moment(new Date(this.state.startDate)).add(1, 'd').isBefore(today, 'day');
    const endInput = moment(new Date(this.state.endInput)).isBefore(today, 'day');

    if ((startInput) || (endInput)) {
      this.setState({ isPassedDateError: true });
    } else {
      this.setState({ isPassedDateError: false });
    }
  }

  confirmDateRange = () => {
    const startInput = moment(this.state.startDate);
    const endInput = moment(this.state.endDate);
    const diff = moment(endInput).diff(startInput, 'days');

    if (diff > 30) {
      this.setState({ isRangeError: true });
    } else {
      this.setState({ isRangeError: false });
    }
  }

  confirmEquality = () => {
    const startInput = new Date(this.state.startDate);
    const endInput = new Date(this.state.endDate);

    if (startInput > endInput) {
      this.setState({ isOOOError: true });
    } else {
      this.setState({ isOOOError: false });
    }
  }

  handleUserChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    }, () => { this.validateValues(); });
  }

  submitCancelOOO = async (e) => {
    e.preventDefault();
    const { userprofile, outOfOffice } = this.props;
    const today = moment();
    const initialStartingDate = moment(this.state.initialStartDate);
    const isActiveOOO = initialStartingDate.startOf('day').isSameOrBefore(today.startOf('day'));
    if (isActiveOOO) {
      // in active OOO, so end it with current time instead
      const payload = {
        startDateTime: moment(this.state.startDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
        endDateTime: moment(this.state.endDate).utc().format('YYYY-MM-DDTHH:mm:ss'),
        actualEndDateTime: moment().utc().format('YYYY-MM-DDTHH:mm:ss')
      };

      if (this.props.outOfOffice.outOfOfficeKey) {
        const oooKeys = {
          memberKey: this.props.userprofile.memberKey,
          outOfOfficeKey: this.props.outOfOffice.outOfOfficeKey
        };
        payload.outOfOfficeKey = this.props.outOfOffice.outOfOfficeKey;
        this.props.updateOutOfOffice(oooKeys, payload);
      }
    } else {
      await this.props.deleteOutOfOffice(userprofile.memberKey, outOfOffice.outOfOfficeKey);
    }
    this.props.history.goBack();
  }

  componentDidMount = async () => {
    await this.props.setHeader(headerSettings);
    await this.props.getMember(this.props.userprofile.memberKey);

    const adjustedTime = this.props.outOfOffice.startDateTime
      ? moment(this.props.outOfOffice.endDateTime).subtract(1, 'd').format('YYYY-MM-DD')
      : moment().add(1, 'd').format('YYYY-MM-DD');

    this.setState({
      startDate: moment(this.props.outOfOffice.startDateTime).format('YYYY-MM-DD'),
      endDate: adjustedTime,
      initialStartDate: this.props.outOfOffice.startDateTime

    });
  }

  render () {
    const startErrorMessage = this.state.isOOOError;
    const rangeErrorMessage = this.state.isRangeError;
    const passedDateErrorMessag = this.state.isPassedDateError;
    const { isOOOError, startDate, endDate, isOutOfOffice, initialStartDate } = this.state;
    const dateFormat = isOOOError ? 'req-alert' : '';
    const initialStartingDate = initialStartDate ? moment(initialStartDate) : moment().add(1, 'd');
    const today = moment();
    const isActiveOOO = initialStartingDate.startOf('day').isSameOrBefore(today.startOf('day'));

    return (
      <React.Fragment>
        <section className='page-content out-of-office-page'>
          <form className='profile-ooo-content'>
            <div className='profile-ooo-container'>
              <div className='profile-ooo-wrapper'>
                <div className='profile-ooo-label'>Out of Office</div>
              </div>
              { isOutOfOffice &&
              <div>
                <div className='profile-ooo-wrapper'>
                  <div className='profile-ooo-label'>Start</div>
                  <div className='profile-ooo-input'>
                    <input
                      type='date'
                      className='reschedule-time profile-ooo-format form-control'
                      value={startDate}
                      name='startDate'
                      onChange={this.handleUserChange}
                      min={moment().format('YYYY-MM-DD')}
                      disabled={isActiveOOO}
                    />

                  </div>
                </div>
                <div className='profile-ooo-wrapper'>
                  <div className='profile-ooo-label'>End</div>
                  <div className='profile-ooo-input'>
                    <input
                      type='date'
                      className={`reschedule-time profile-ooo-format ${dateFormat} form-control`}
                      value={endDate}
                      name='endDate'
                      onChange={this.handleUserChange}
                      min={moment().format('YYYY-MM-DD')}
                    />
                  </div>
                </div>
              </div>
              }
              { startErrorMessage &&
              <div className='alert-message fade-in center-content'>
                <div><img className='alert-icon' src={alertIcon} /></div>
                <div>{MEMBER.ERROR_START_DATE}</div>
              </div>
              }
              { rangeErrorMessage &&
              <div className='alert-message fade-in center-content'>
                <div><img className='alert-icon' src={alertIcon} /></div>
                <div>{MEMBER.ERROR_DATE_RANGE}</div>
              </div>
              }
              { passedDateErrorMessag &&
              <div className='alert-message fade-in center-content'>
                <div><img className='alert-icon' src={alertIcon} /></div>
                <div>{MEMBER.ERROR_PASSED_DATE}</div>
              </div>
              }
            </div>
            <div className='bottom-button-wrapper profile-ooo-buttons'>
              <div>
                <button className='ooo-secondary-botton' type='reset' onClick={this.submitCancelOOO}>
                    Cancel Out of Office
                </button>
              </div>
              <div className=' push'>
                <button
                  disabled={!(isOutOfOffice && !isOOOError && !rangeErrorMessage && !passedDateErrorMessag)}
                  onClick={this.submitOutofOffice}
                  className='login-primary-button' type='submit'>
                  Save
                </button>
              </div>
            </div>
          </form>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { userprofile } = state;
  return {
    outOfOffice: _.get(memberSelectors.memberData(state.member), 'outOfOffice', {}),
    userprofile
  };
};

const mapDispatchToProps = (dispatch) => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  getMember: bindActionCreators(dashboardActions.getMember, dispatch),
  setOutOfOffice: bindActionCreators(userprofileActions.setOutOfOffice, dispatch),
  updateOutOfOffice: bindActionCreators(userprofileActions.updateOutOfOffice, dispatch),
  deleteOutOfOffice: bindActionCreators(userprofileActions.deleteOutOfOffice, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutOfOffice));
